module.exports = __webpack_public_path__ + "img/17.d1fe21ea.jpg";